import { render, staticRenderFns } from "./WorkFlowSituacaoPedidoManage.vue?vue&type=template&id=08015d5b&scoped=true"
import script from "./WorkFlowSituacaoPedidoManage.vue?vue&type=script&lang=js"
export * from "./WorkFlowSituacaoPedidoManage.vue?vue&type=script&lang=js"
import style0 from "./WorkFlowSituacaoPedidoManage.vue?vue&type=style&index=0&id=08015d5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08015d5b",
  null
  
)

export default component.exports